<template>
  <div class="search-bar">
    <AppInput v-bind="$attrs" append-icon="far fa-search" @input="updateSearch" />
  </div>
</template>

<script>
// Components
import AppInput from 'Ui/AppInput'

export default {
  name: 'SearchBar',
  inheritAttrs: false,

  components: {
    AppInput,
  },

  methods: {
    updateSearch(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style scoped>
.search-bar >>> .app-input {
  font-weight: 600;
}
</style>
